import {Grid, Select} from "@mantine/core";
import {supportedCountries} from "./Address.types";
import {UseFormReturnType} from "@mantine/form/lib/use-form";

interface Props {
    form: UseFormReturnType<any>,
    disableAllFields?:boolean
}

function Address({ form, disableAllFields }:Props) {

    function getSupportedCountriesData() {
        return Object
            .keys(supportedCountries(form))
            .sort((a,b)=> a.localeCompare(b))
            .map(key => ({value: key, label: supportedCountries(form)[key].display}))
    }

    function onChange(countryCode:any){
        form.setFieldValue("address1", '');
        form.setFieldValue("address2", '');
        form.setFieldValue("zone", '');
        form.setFieldValue("postalCode", '');
        form.setFieldValue("city", '');
        form.setFieldValue("countryCode", countryCode);
    }

    function renderSupportedCountryFields(){
        if (!form.values.countryCode){
            return null;
        } else {
            let formItems = supportedCountries(form, disableAllFields)[form.values.countryCode].formItems;
            return formItems.map((formItem, index) => (
                <Grid.Col span={12} key={index}>
                    {formItem}
                </Grid.Col>
            ))
        }
    }

    return (
        <Grid>
            <Grid.Col span={12}>
                <Select
                    disabled={disableAllFields}
                    description="We only support a select number of countries at the moment. If you do not see your country in this list, please contact support."
                    label="Country"
                    required
                    placeholder="Please select a Country"
                    clearable={!disableAllFields}
                    searchable
                    {...form.getInputProps("countryCode")}
                    onChange={onChange}
                    data={getSupportedCountriesData()}/>
            </Grid.Col>
            {renderSupportedCountryFields()}
        </Grid>
    )
}

export default Address;